import axios from "axios";
import { apiBaseUrl, sessionStorageToken } from "../Helper";
import { Toast } from "./useToast";


export const Axios = (function () {
    const getServicePayload = (apiCoreServiceInstance) => ({
        get: (url, options = {}) => apiCoreServiceInstance.get(url, { ...options }),
        post: (url, data, options = {}) =>
            apiCoreServiceInstance.post(url, data, { ...options }),
        put: (url, data, options = {}) =>
            apiCoreServiceInstance.put(url, data, { ...options }),
        patch: (url, data, options = {}) =>
            apiCoreServiceInstance.patch(url, data, { ...options }),
        delete: (url, options = {}) =>
            apiCoreServiceInstance.delete(url, { ...options }),
    });

    const axiosInstance = axios.create({
        baseURL: apiBaseUrl(),
        headers: {
            'Content-Type': 'application/json',
        }

    })



    const apiCoreServiceRequestInterceptor = (axiosConfig) => {
        return axiosConfig;
    };
    const apiCoreServiceRequestErrorInterceptor = (error) => {
        Promise.reject(error);
    }



    // Response interceptors config
    const apiCoreServiceResponseInterceptor = (response) => {
        return response.data;

    }
    const apiCoreServiceResponseErrorInterceptor = (error) => {
        if (error.code === "ERR_NETWORK") {
            return Promise.reject(new Error(error));
        }
        if (error.response.data.code === 401) {
            const isWebView = sessionStorage.getItem('is_webView')
            if (!!isWebView) {
                if (window?.FlutterChannel) {
                    window.FlutterChannel.postMessage("logout");
                }
                else {
                    Toast("Flutter Channel Not Found. Unauthorized access", 'error', false);
                }
            }
            else {
                Toast(`Unauthorized access, session : ${isWebView}`, 'error', false);
                sessionStorage.removeItem(sessionStorageToken());
                window.location = `/`
            }
            return Promise.reject(new Error(error));
        }
        return Promise.reject(error.response.data);

    };

    axiosInstance.interceptors.request.use(
        apiCoreServiceRequestInterceptor,
        apiCoreServiceRequestErrorInterceptor,
    );

    axiosInstance.interceptors.response.use(
        apiCoreServiceResponseInterceptor,
        apiCoreServiceResponseErrorInterceptor,
    );


    return getServicePayload(axiosInstance);


})()